import { Calc } from "../../math/Calc.js";
import { ScrollbarData } from "../Scrollbar.js";
import { ScrollbarListDynamic } from "../ScrollbarListDynamic.js";
import { IScrollbarBehaviour } from "./IScrollbarBehaviour.js";

export class ScrollbarBehaviourIndex implements IScrollbarBehaviour {
    public getIndex(scrollbar: ScrollbarListDynamic): number {
        if (!scrollbar.view)
            return -1;

        if (scrollbar.view.getItems().length === 0) {
            if ((scrollbar.thumb.offsetHeight + scrollbar.dragger.top) > (scrollbar.track.offsetHeight - this.getMarginBottom(scrollbar)))
                return 1;
            return -1;
        }

        var trackRange = scrollbar.track.offsetHeight - scrollbar.thumb.offsetHeight;
        var marginTop = this.getMarginTop(scrollbar);
        var marginBottom = this.getMarginBottom(scrollbar);
        var trackRangeMargin = trackRange - (marginTop + marginBottom);
        var ratio = Calc.clamp(scrollbar.dragger.top / trackRange, 0, 1);
        if (ratio < (marginTop / trackRange)) {
            //top
            return -1;
        }
        else if (ratio > ((trackRange - marginBottom) / trackRange)) {
            //bottom
            return scrollbar.view.getItems().length;
        }
        else {
            //content
            var maxIndex = scrollbar.view.getItems().length - 1;
            if (trackRangeMargin <= 0) {
                return 0;
            } else {
                var ratio = (scrollbar.dragger.top - marginTop) / trackRangeMargin;
            }
            var index = Calc.clamp(Math.round(ratio * maxIndex), 0, maxIndex);
            return index;
        }
    }

    public fromView(scrollbar: ScrollbarListDynamic): ScrollbarData {
        var items = scrollbar.view.getItems();

        var offsetTop = scrollbar.view.content.offsetTop;
        var scrollTop = scrollbar.view.scroller.scrollTop;

        var marginTop = this.getMarginTop(scrollbar);
        var marginBottom = this.getMarginBottom(scrollbar);

        var view = scrollbar.view;

        if (marginTop || marginBottom) {
            var yPos = 0;
            if (scrollTop < offsetTop) {
                //top
                yPos = (scrollTop / offsetTop) * marginTop;
            }
            else if (scrollTop > (offsetTop + view.content.offsetHeight)) {
                //bottom
                var offsetBottom = offsetTop + view.content.offsetHeight;
                var bottomHeight = view.scroller.scrollHeight - offsetBottom;
                var pixelsToScroll = bottomHeight - view.scroller.clientHeight;

                if (pixelsToScroll <= 0) {
                    yPos = scrollbar.track.offsetHeight - scrollbar.thumb.offsetHeight;
                }
                else {
                    yPos = ((scrollTop - offsetBottom) / pixelsToScroll) * marginBottom;
                    yPos += scrollbar.track.offsetHeight - (marginBottom + scrollbar.thumb.offsetHeight);
                }

            } else {
                //content
                var h = scrollbar.track.offsetHeight - (marginTop + marginBottom + scrollbar.thumb.offsetHeight);
                var firstIndex = view.first ? view.first.index : 0;
                var r = firstIndex / Calc.clampMin(items.length - 1, 1);
                yPos = r * h + marginTop;
            }

            var ratio = yPos / (scrollbar.track.offsetHeight - scrollbar.thumb.offsetHeight);

            var scrollHeight = 1;
            var k = items.length > 0 ? 10 : 0;
            var minItemsCount = 1 / (1 - (marginTop + marginBottom + k) / scrollbar.track.offsetHeight);
            var clientHeight = 1 / Calc.clampMin(items.length, minItemsCount);
            return {
                scrollHeight: scrollHeight,
                scrollTop: ratio * (scrollHeight - clientHeight),
                clientHeight: clientHeight
            };

        } else {
            var maxEntries = items.length;
            var firstIndex = view.first ? view.first.index : 0;
            return {
                scrollHeight: maxEntries,
                scrollTop: firstIndex,
                clientHeight: 1
            };
        }
    }

    private getMarginTop(scrollbar: ScrollbarListDynamic): number {
        var offsetTop = scrollbar.view.content.offsetTop;
        if (offsetTop <= 0)
            return 0;
        return 10;
    }

    private getMarginBottom(scrollbar: ScrollbarListDynamic): number {
        var offsetTop = scrollbar.view.content.offsetTop;
        var offsetBottom = scrollbar.view.scroller.scrollHeight - (scrollbar.view.content.offsetHeight + offsetTop + scrollbar.view.scroller.offsetHeight);
        if (offsetBottom <= 0)
            return 0;
        return 10;
    }
}